/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取印花活动详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SelectPrintingDetailParams {
  constructor(public activityId: string) {}
}

export default async function (
  params: SelectPrintingDetailParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.selectPrintingDetailResponse;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/selectPrintingDetail`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
